import { useMemo } from 'react';
import { Helmet } from 'react-helmet';
import { Outlet, useParams } from 'react-router-dom';

import { DetailsSidebarProvider } from '@eluve/components';
import { AppointmentContextProvider } from '@eluve/frontend-appointment-hooks';
import {
  LoggerArgs,
  LoggingContextProvider,
  useExtendedLogger,
} from '@eluve/logger';

import { AppointmentGuard } from './AppointmentGuard';
import { AppointmentHeader } from './components/AppointmentHeader';

export const AppointmentsMainLayout: React.FC = () => {
  const { appointmentId, tenantId } = useParams() as {
    tenantId: string;
    appointmentId: string;
  };

  const appointmentLoggerArgs: LoggerArgs = useMemo(
    () => ({
      name: 'AppointmentScoped',
      metadata: { tenantId, appointmentId },
    }),
    [tenantId, appointmentId],
  );
  const appointmentLogger = useExtendedLogger(appointmentLoggerArgs);

  return (
    <LoggingContextProvider loggerInput={appointmentLogger}>
      <AppointmentContextProvider
        tenantId={tenantId}
        appointmentId={appointmentId}
      >
        <AppointmentGuard>
          <DetailsSidebarProvider>
            <Helmet>
              <title>Appointments | Eluve</title>
            </Helmet>
            <AppointmentHeader />
            <Outlet />
          </DetailsSidebarProvider>
        </AppointmentGuard>
      </AppointmentContextProvider>
    </LoggingContextProvider>
  );
};
